import React, { useState, useEffect, useMemo } from 'react'
import axios from 'axios'

import VideoModal from '../ui/VideoModal'
import { VideoLibrary, Notice } from './media'
import './media.css'

/*
 * COACHES' VIDEO — the picker.
 *
 * The same body as the sponsor picker (VideoLibrary), against the same library
 * request — GET {VIDEOSERVER_API}upload/{APP_NAME} — with the one difference
 * that belongs to this screen: a coaches' video holds exactly one clip, so
 * picking replaces the record's VideoID and closes, instead of posting an
 * attachment. No request is made here at all; the form saves it.
 */

export default function CoachesSelectVideo(props) {

  const [videos, setVideos] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')
  const [query, setQuery] = useState('')
  const [preview, setPreview] = useState(-1)

  useEffect(() => {
    loadVideos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadVideos = () => {
    setIsLoading(true)
    setError('')
    axios.get(process.env.REACT_APP_VIDEOSERVER_API + 'upload/' + process.env.REACT_APP_NAME)
      .then(res => {
        setVideos(res.data.sort((a, b) => (a.Timestamp < b.Timestamp) ? 1 : -1))
        setIsLoading(false)
      })
      .catch(err => {
        setIsLoading(false)
        setError('The video library could not be loaded.')
      })
  }

  const shown = useMemo(() => {
    const all = Array.isArray(videos) ? videos.filter((item) => item && item.id) : []
    const s = query.trim().toUpperCase()
    if (!s) return all
    return all.filter((item) => {
      const id = String(item.id || '').toUpperCase()
      const friendly = String(item.friendlyName || '').toUpperCase()
      return id.indexOf(s) > -1 || friendly.indexOf(s) > -1
    })
  }, [videos, query])

  const clips = useMemo(
    () => shown.map((item) => ({
      fileId: item.id,
      name: item.friendlyName ? item.friendlyName : item.id,
      subtitle: item.id,
    })),
    [shown]
  )

  useEffect(() => {
    if (preview >= clips.length) setPreview(-1)
  }, [clips.length, preview])

  const selectVideo = (item) => {

    props.setRecord({ ...props.record, VideoID: item.id })
    props.handleClose(false)
  }

  const currentId = props.record ? props.record.VideoID : ''

  return (
    <>
      {error ? <Notice kind="crit" onClose={() => setError('')}>{error}</Notice> : null}

      <VideoLibrary
        videos={shown}
        loading={isLoading}
        query={query}
        onQuery={setQuery}
        isPicked={(item) => !!currentId && item.id === currentId}
        onPick={(item) => selectVideo(item)}
        onPreview={(item) => setPreview(shown.indexOf(item))}
        pickLabel="Select"
        pickedLabel="Selected"
        emptyTitle="No videos"
        emptyHint="No videos match these filters."
      />

      {preview >= 0 && clips[preview] ? (
        <VideoModal
          items={clips}
          index={preview}
          title="Video library"
          onIndex={setPreview}
          onClose={() => setPreview(-1)}
        />
      ) : null}
    </>
  )
}
